import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { action } from "@ember/object"
import styles from "./two-line-icon-row.module.css"

@tagName("")
export default class TwoLineIconRow extends Component {
  styles = styles

  @action
  onClick() {
    if (this.clickAction) {
      this.clickAction()
    }
  }
}
